import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

// import swiper styles bundle
import 'swiper/css/bundle';

// Import Swiper and required modules

// Initialize Swiper
const hero = new Swiper('.hero-slider', {
  modules: [Navigation, Pagination],
  slidesPerView: 1,
  spaceBetween: 0,
  navigation: {
    nextEl: '.hero-slider-next',
    prevEl: '.hero-slider-prev',
  },
  pagination: {
    el: '.hero-slider-pagination',
    clickable: true,
  },
});

document.addEventListener('DOMContentLoaded', function () {
  hero.init();
  console.log(`Swiper initialized`);
});
